import { render, staticRenderFns } from "./addBrandModal.vue?vue&type=template&id=966be1ba"
import script from "./addBrandModal.vue?vue&type=script&lang=js"
export * from "./addBrandModal.vue?vue&type=script&lang=js"
import style0 from "./addBrandModal.vue?vue&type=style&index=0&id=966be1ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports